import { graphql } from '@/generated/gql';

export const INTAKE_SELECT_INTENT_STEP_MUTATION = graphql(/* GraphQL */ `
  mutation SelectIntent($data: SvbrgChatSessionSelectIntentInput!) {
    sevenbridges {
      chatSession {
        selectIntent(data: $data) {
          id
        }
      }
    }
  }
`);
